import React, { forwardRef } from 'react'
import { BeaconRenderProps } from 'react-joyride'
import { BeaconButton } from './BeaconTutorial.styles'

export const MpBeaconTutorial = forwardRef<HTMLElement, BeaconRenderProps>((props: BeaconRenderProps, ref: any) => {
  MpBeaconTutorial.displayName = 'MpBeaconTutorial'
  return <BeaconButton ref={ref} {...props} />
})
